// Modules
import React, { useMemo, useState } from 'react'
import { ErrorResponse } from 'apollo-link-error'

// Applications
import { useApp } from 'context'
import { useRecoverHook } from 'hooks'
import { PatientToken } from 'typings/recoverpassword'
import { StatusMessage, ContactType } from 'typings'
import { OutputErrorCode, OutputErrorMsg } from 'constants/index'

// Components
import { ResendTokenType, TokenProcessSSO } from 'typings/account'
import { ValidateDestinationToken } from 'components/Presenters/ValidateDestinationToken'
import { ValidateTokenInitial } from 'components/Presenters/ValidateToken'

export const ValidateTokenWrapper: React.VFC = () => {
    const recover = useRecoverHook()
    const { openToast } = useApp()
    const [isLoading, setLoading] = useState<boolean>(false)
    const [isDisableButton, setIsDisableButton] = useState(false)
    const [isLoadingButton, setIsLoadingButton] = useState(false)
    const [fieldState, setFieldState] = useState<StatusMessage>({ status: '', message: '' })
    const isDestinationMobile = useMemo(() => (recover.contact?.contactType || recover.contact?.type) === ContactType.MOBILE, [
        recover.contact,
    ])

    const handleSubmit = async (values: ValidateTokenInitial) => {
        setIsDisableButton(true)
        setIsLoadingButton(true)
        setFieldState({ status: 'loading', message: 'Validando código' })
        const { token: rawToken } = values
        const token = rawToken.join('')

        try {
            recover.setSubmitting(true)
            await recover.setValidateToken({ token })
            const patientToken: PatientToken = {
                userName: recover.username!,
                token,
            }
            const { checkToken } = await recover.checkToken(patientToken)
            recover.setSubmitting(false)
            if (checkToken.message === 'OK') {
                setFieldState({ status: 'success', message: 'Código validado' })
                setTimeout(() => {
                    recover.nextStep()
                }, 1200)
                return
            }
            if (!checkToken) {
                setFieldState({
                    status: 'error',
                    message: OutputErrorMsg.INVALIDTOKEN,
                })
            }
        } catch (err) {
            setIsLoadingButton(false)
            recover.setSubmitting(false)
            const e: ErrorResponse = err
            if (e.graphQLErrors) {
                const codeError = e.graphQLErrors[0].extensions?.code
                if (codeError === OutputErrorCode.INVALIDTOKEN || codeError === OutputErrorCode.EXPIREDTOKEN) {
                    setFieldState({
                        status: 'error',
                        message:
                            OutputErrorCode.INVALIDTOKEN === codeError ? OutputErrorMsg.INVALIDTOKEN : OutputErrorMsg.EXPIREDTOKEN,
                    })
                    return
                }
            }
            openToast('Ocorreu um erro')
        }
    }

    const handleResendToken = async (contactType: ContactType) => {
        try {
            setLoading(true)

            const patientLogin: ResendTokenType = {
                contactId: recover.contact?.id,
                cpf: recover.username,
                dispatchType: contactType,
                process: TokenProcessSSO.CHANGE_PASS,
            }

            await recover.resendTokenV2(patientLogin)
        } catch (error) {
            openToast('Ocorreu um erro')
        } finally {
            setLoading(false)
        }
    }

    return (
        <ValidateDestinationToken
            fieldState={fieldState}
            handleResendToken={handleResendToken}
            handleSubmit={handleSubmit}
            isDestinationMobile={isDestinationMobile}
            isDisableButton={isDisableButton}
            isLoading={isLoading}
            isLoadingButton={isLoadingButton}
        />
    )
}
